// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> rye-bunker-hill
// Generated: 2026-11-03T23:03:27.661Z
// Counts: 1 design, 83 content, 8 slot group, 1 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover elevated style and Texas charm at Rye Bunker Hill. Thoughtfully designed <a class=\"richtext-link\" href=\"/floor-plans\">interiors</a> pair open living spaces, chef-inspired kitchens, and modern finishes with a community created for enjoying more of every day.</p><p>Beyond your front door, <a class=\"richtext-link\" href=\"/amenities\">inviting indoor and outdoor spaces</a> offer opportunities to relax, recharge, stay active, or get some work done. Whether you're spending an afternoon by the pool, heading out on the nearby trail system, or settling into your favorite space at home, Rye Bunker Hill brings comfort and convenience together.</p><p>Explore Rye Bunker Hill and discover your next home in Garland.</p><p><em>Your future at Rye Bunker Hill is as expansive as that endless Texas sky.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Located on Bunker Hill Road, Rye Bunker Hill connects you to shopping, dining, recreation, and destinations throughout Garland and the surrounding area. Firewheel Town Center, Spring Creek Forest Preserve, and Breckinridge Park are nearby, while SH-78 and President George Bush Turnpike provide convenient connections throughout the region.</p><p>Direct access to Garland's regional trail system also makes it easy to explore more of the area right from the community.</p><p>Visit our Neighborhood page to discover more of what's nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resort-Style Apartment Amenities in Garland, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pickleball, Fitness, Coworking &amp; More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Rye Bunker Hill</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect With Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3 Bedroom Apartments in Garland, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Rye Bunker Hill </h2><h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Rye Bunker Hill Apartment Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the Rye Bunker Hill Photo Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1>MODERN STYLE FOR THE MODERN TEXAN</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in Garland, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Site Map in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Firewheel Town Center</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Shopping, Dining, Parks &amp; Trails Near Rye Bunker Hill</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Perks For Local Employees</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Local Hospital &amp; Medical Center</p></li><li><p>Regional School District</p></li><li><p>City Fire &amp; Police Departments</p></li><li><p>Municipal Government Employees</p></li><li><p>State University Faculty &amp; Staff</p></li><li><p>Federal &amp; Military Personnel</p></li><li><p>Community College &amp; Trade Schools</p></li><li><p>Nonprofit &amp; Faith-Based Organizations</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Garland, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Dog Park &amp; Pet Spa at Rye Bunker Hill</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See what residents say about life at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Rye Bunker Hill in Garland, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule Your Apartment Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Designed For Modern Luxury</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resort-Style Living, Every Day</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Garland From Rye Bunker Hill</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Apartment Tours in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of your time at home with spaces designed for recreation, fitness, productivity, and relaxation.</p><p>Take a swim in the resort-style saltwater pool, play a match on the pickleball courts, practice your swing with the indoor golf simulator, or fit a workout into your day at the fitness center. Private work pods provide space to focus, while the coffee bar and expansive clubroom offer additional places to gather or unwind.</p><p>Outdoor amenities continue with a lake pavilion and grilling stations, along with direct access to Garland's regional trail system.</p><p>Inside your <a class=\"richtext-link\" href=\"/floor-plans\">home</a>, enjoy quartz countertops, designer backsplashes, custom cabinetry, stainless steel appliances, in-home washers and dryers, private patios or balconies, and spacious closets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about Rye Bunker Hill? Our leasing team can provide information about current <a class=\"richtext-link\" href=\"/floor-plans\">availability</a>, lease options, community <a class=\"richtext-link\" href=\"/amenities\">features</a>, or an upcoming visit.</p><p>Give us a call, visit the leasing office, or complete the contact form below to get in touch. We look forward to helping you learn more about Rye Bunker Hill.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a space that feels like your own with one-, two-, and three-bedroom apartment floor plans at Rye Bunker Hill. Open layouts blend style and functionality, with expansive living areas, generously sized bedrooms, abundant natural light, and thoughtful storage throughout.</p><p>Chef-inspired kitchens feature quartz countertops, stainless steel appliances, and large islands or wraparound bars, creating an inviting centerpiece for each home. Expansive closets with custom wood shelving offer plenty of room for storage, while oversized windows fill the living spaces with natural light. Select floor plans also feature built-in desks, private studies, and additional custom storage options.</p><p>Whether you're looking for a streamlined one-bedroom layout or the additional space of a two- or three-bedroom home, Rye Bunker Hill offers a variety of options to explore.</p><p>Browse available floor plans above to compare layouts, square footage, bedroom options, and current availability. When you <a class=\"richtext-link\" href=\"/gallery\">find a space that catches your eye</a>, schedule an appointment online or call today to <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> and experience Rye Bunker Hill in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your day-to-day at Rye Bunker Hill. Browse the gallery for a closer look at <a class=\"richtext-link\" href=\"/amenities\">apartment interiors, community spaces, and outdoor areas</a> throughout the property.</p><p>See the details of the kitchens and living spaces, get a feel for the community's indoor gathering areas, and explore outdoor spaces designed for relaxing, recreation, and time outside.</p><p>Photos are only the beginning. Schedule a tour to experience Rye Bunker Hill in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover what's around Rye Bunker Hill from a location on Bunker Hill Road near SH-78 and President George Bush Turnpike. Shopping, dining, entertainment, parks, and outdoor recreation can all be found throughout the surrounding Garland area.</p><p>Visit Firewheel Town Center for shopping, restaurants, and entertainment, or head outdoors to explore Spring Creek Forest Preserve and Breckinridge Park. Direct access to the City of Garland regional trail system also provides another way to experience the surrounding area right from the community.</p><p>When you're heading farther out, President George Bush Turnpike connects Garland with Richardson, Plano, and destinations throughout the Dallas-Fort Worth area, including CityLine in Richardson.</p><p>Explore the neighborhood map above to find more destinations near Rye Bunker Hill.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs are welcome at Rye Bunker Hill. Pet-focused amenities make caring for your companion more convenient, including a spacious on-site dog park for outdoor time and a pet spa for grooming and cleanup.</p><p>Up to two pets are permitted per <a class=\"richtext-link\" href=\"/floor-plans\">apartment</a>. Monthly pet rent is $25 per pet, with a $300 non-refundable pet deposit for one pet or $500 total for two pets. Breed restrictions apply.</p><p>Contact the Rye Bunker Hill leasing team for complete pet guidelines, restrictions, fees, and current policy information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.pet_deposit_sublabel": {
    "overrideType": "VALUE",
    "customValue": "(Non Refundable)",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Modern Living at </h2><h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Rye Bunker Hill beyond the screen. Schedule a tour to explore the community, step inside available apartment homes, and get a closer look at the spaces and features that interest you most.</p><p>During your visit, you can explore <a class=\"richtext-link\" href=\"/floor-plans\">available layouts</a>, tour <a class=\"richtext-link\" href=\"/amenities\">community spaces</a>, and connect with the leasing team to get answers to your questions.</p><p>Choose an available tour option and time above to plan your visit.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_black_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_mono_black_logo_media.alt_text"
      }
    }
  },
  "hero.slide_1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image_media.alt_text"
      }
    }
  },
  "hero.slide_2_image": {
    "sourceIndex": 79,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a086fa-c7b9-73bf-95ad-52556abb4237.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a plush sectional sofa, abstract art, and a floor lamp."
      }
    }
  },
  "hero.slide_3_image": {
    "sourceIndex": 8,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a0346d-5fd4-7713-a5bd-bf5f1013ecae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and a farmhouse sink."
      }
    }
  },
  "hero.slide_4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-25d3-76b9-96bc-8b43aeb18559.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A stylish living room with a sectional sofa, accent chair, coffee table, and artwork."
      }
    }
  },
  "hero.slide_5_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4851-757b-9b37-5481fe27dcb6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern bathroom with a walk-in glass shower and view of bedroom."
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_ced49608-509c-46f3-9051-4a46b7adddf8",
      "custom_be8f2fb1-1eaf-4e65-b8cc-d32341446a95",
      "custom_f2c7df2b-6451-4ca5-86a1-cdd3cf1e5faf",
      "custom_b5bfd894-5486-4b6f-af2f-a8ae85f5613d",
      "custom_3c75ec09-885b-48c3-a8c2-69bde55d9f41",
      "custom_492b2fd5-0b60-4911-ac13-c6a1dd0e7098",
      "custom_4812997d-de17-49bd-a997-f11527ca4f35",
      "custom_25bc76ec-a103-4546-9541-a0af21457999",
      "custom_1b82a0d2-cddd-4e89-af4d-808daea0c2de",
      "custom_6309ff6d-aec3-48bc-b066-7c84de47e03c",
      "custom_67634a02-76eb-4742-805f-569cc3ad794b",
      "custom_b79bec5a-516c-42e0-b5ef-128934ed9d4d",
      "custom_4b413452-81be-434e-a05a-b1610163c585",
      "custom_71afde3b-335c-45e2-affc-761479b0cc47",
      "custom_bb0fadc5-d10f-4535-9296-a91bfef88387",
      "custom_c58cdba0-7068-48a9-a9be-7c0300b16ccf",
      "custom_fbf16550-8cf1-4833-9114-c68533df03b2",
      "custom_0a675119-bb02-4c20-b12a-dcc96ddb8364",
      "custom_df480afd-7bbd-489b-8c76-d19194bf4004",
      "custom_66203269-3624-45c3-a8ec-90aa972b1fc3",
      "custom_c2aaebf4-8e53-471f-b219-bb6f5dcf7045",
      "custom_b218d983-b6ef-4f84-9554-492ee66656b7",
      "custom_440254e0-714c-4811-bbf7-4a29de1c9c0b",
      "custom_dc579178-45ac-46a9-a1b3-45dbe1a87fb1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  }
};
